module.exports = __webpack_public_path__ + "img/hr-red-asterisk-11.2b3b8f00.png";